
import React from 'react';
import { Table} from 'react-bootstrap';
import { BLANK, BLANK_ARR } from '../helpers/constants';
import { DUMMY } from '../helpers/functions';
import {StyleContext} from "../context"
import InputRow from './InputRow';
import TableEntry from './TableEntry';
import TableFooter from './TableFooter';
import TableHeader from './TableHeader';

const BudgetTable = ({
    onNameSelect=DUMMY("on name select"),
    onNameChange =  DUMMY("on name change"),
    onValueChange = DUMMY("on value change"),
    addEntry =  DUMMY("add entry"),
    clearAll =  DUMMY("clear table"),
    deleteRow =  DUMMY("delete row"),
    samples = [],
    type = BLANK,
    variant = BLANK,
    items = BLANK_ARR,
    sum = 0
}) =>
(
    <StyleContext.Provider value={{samples, type, variant, items, sum}}>
        <Table striped bordered hover variant={variant}>
            <TableHeader/>
            <tbody>
                {
                    items.map((e, id) =>
                    (
                        <TableEntry
                            deleteRow={deleteRow}
                            elem={e}
                            id={id}
                            key={id}/>
                    ))
                }
                <InputRow
                    addEntry={addEntry}
                    onNameChange={onNameChange}
                    onValueChange={onValueChange}
                    onNameSelect={onNameSelect}/>
            </tbody>
            <TableFooter clearAll={clearAll}/>
        </Table>
    </StyleContext.Provider>
)



export default BudgetTable;
